
<template>
  <a-card :bordered="false">
    <component @onEdit="handleEdit" @onGoBack="handleGoBack" :record="record" :is="currentComponent"></component>
  </a-card>
</template>

<script>

import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
// 动态切换组件
import List from '@/views/a-trade/collection/table/List'
import Edit from '@/views/a-trade/collection/table/Edit'

export default {
  name: 'TagInformation',
  components: {
    AInput,
    ATextarea,
    List,
    Edit
  },
  data () {
    return {
      currentComponent: 'List',
      record: ''
    }
  },
  methods: {
    handleEdit (record) {
      this.record = record || ''
      this.currentComponent = 'Edit'
      console.log(record)
    },
    handleGoBack () {
      this.record = ''
      this.currentComponent = 'List'
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.currentComponent = 'List'
    }
  }
}
</script>
